import { fromTransitOperationResponse, toUpdateRequest } from '../models/mapper'
import { updateTransitOperationV2 } from './http'
import { TransitOperation } from '../models/types'
import { TransitOperationSave } from '../models/request'

// eslint-disable-next-line import/prefer-default-export
export async function updateTransitOperation(id: number, transitOperation: TransitOperationSave): Promise<TransitOperation> {
  const request = toUpdateRequest(transitOperation)
  const response = await updateTransitOperationV2(id, request)
  return fromTransitOperationResponse(response)
}

